const messagesZh = {
    tracking_number: '货运追踪号',
    hello: 'Hello world',
    language: '语言',
    currency: '货币',
    copyright: '版权声明',
    allright: '版权所有。',
    sort: '排序',
    filter: '过滤',
    sort_by: '排序',
    refine_by: '过滤选项',
    price: '价格',
    average_rating: '平均评分',
    reviews: '评论',
    item_code: '产品编码',
    qty: '个数',
    register_enable:'注册账户激活',
    wholesale_prices: '批发价',
    add_to_cart: '加入购物车',
    add_to_favorites: '加入收藏',
    description: '描述',
    reviews: '评论',
    shipping_payment: '货运 & 支付',
    customer_who_also_bought: '买了这个产品的人还买了什么',
    add_review: '增加评论',
    view_all_review: '查看所有评论',
    you_must_chosen: '您必须选择',
    cart: '购物车',
    discount_codes: '折扣',
    subtotal: '小计',
    sub_weight: '总重',
    sub_volume: '总体积',
    shipping_cost: '运费',
    discount: '折扣',
    grand_total: '总计',
    proceed_to_pay: '继续付款',
    checkout: '下单页面',
    welcome_to_checkout: '欢迎来到结帐，填写下面的字段来完成您的购买！',
    already_registered: '已经注册？ 点击此处登录',
    shipping_address: '发货地址',
    new_address: '新地址',
    first_name: '名',
    last_name: '姓',
    email_address: '邮箱地址',
    telephone: '电话',
    street: '街道',
    country: '国家',
    state: '省',
    city: '城市',
    zip_code: '邮编',
    create_an_account: '创建一个帐户供以后使用',
    password: '密码',
    confirm_password: '确认密码',
    payment_method: '支付方式',
    shipping_method: '货运方式',
    coupon_codes: '优惠券代码（可选）',
    enter_your_coupon_code: '输入您的优惠券代码',
    review_your_order: '查看你的订单',
    place_order_now: '现在下单',
    return_policy: '退货条约',
    privacy_policy: '隐私条约',
    contact_us: '联系我们',
    about_us: '关于我们',
    my_favorite: '我的收藏',
    my_order: '我的订单',
    shopping_cart: '购物车',
    account: '账户',
    home: '首页',
    sign_in: '登录',
    forgot_password: '忘记密码？',
    register: '注册',
    login: '登录',
    register_account: '注册账户',
    my_account: '我的账户',
    logout: '退出登录',
    edit_account: '编辑账户',
    change_password: '更改密码',
    add_new_address: '增加新地址',
    default_address: '默认地址',
    name: '名字',
    address: '地址',
    operation: '操作',
    customer_address: '货运地址',
    reorder: '重新下单',
    view_order: '查看订单',
    order_increment_id: '订单号',
    date: '日期',
    operate: '操作',
    customer_order: '我的订单',
    order_status: '订单状态',
    order_date: '订单日期',
    shipping_address: '货运地址',
    shipping_method: '货运方式',
    payment_method: '支付方式',
    items_ordered: '订单产品',
    product_image: '产品图片',
    grand_total: '总计',
    product_info: '产品信息',
    product_review: '产品评论',
    product_favorite: '产品收藏',
    send_authorization_code: '发送授权码',
    forget_password: '忘记密码',
    click_here: '点击这里',
    to_login: '去登陆',
    reset_accout_success: '重置密码成功，您可以',
    reset_password_success: '充值密码成功',
    forget_password_send_success: '充值密码发送成功',
    we_send_message_to_your_email: '我们已经给您的邮箱发送了一封邮件',
    follow_the_instructions_provided: '请按照邮件中提供的说明重置您的密码。',
    donot_receive_email: '没有收到我们的邮件？',
    click_here_to_retry: '点击这里重新发送邮件',
    check_your_bulk_junk_email_folder: '检查您的垃圾邮件文件夹。',
    confirm_your_identity_to_reset: '如果你仍然无法找到它，请确认你的身份重置密码',
    click: '点击',
    support_center: '帮助中心',
    for_help: '寻求帮助',
    reset_password: '重置密码',
    our_email_address: '我们的邮箱地址',
    contacts: '联系我们',
    submit: '提交',
    captcha: '验证码',
    review: '评论',
    rate: '评星',
    summary: '概要',
    name: '姓名',
    product_review: '产品评论',
    add_review: '新增评论',
    reviews: '评论',
    thank_you_for_purchase: '您的订单，我们已经收到，感谢您的购买',
    your_order_is: '您的订单号',
    receive_an_confirm_email: '您将收到一份订单确认电子邮件，其中包含您订单的详细信息以及跟踪其进度的链接。',
    continue_shopping: '继续购物',
    order_remark:'订单备注 (可选)',
    fill_order_remark:'你可以在下面填写您的备注信息',
    average_rating:'平均评分',
    stars_5:'5 星',
    stars_4:'4 星',
    stars_3:'3 星',
    stars_2:'2 星',
    stars_1:'1 星',
    hello: '',
    hello: '',
    hello: '',
    hello: '',
    hello: '',
    hello: '',
    hello: '',
    hello: '',
    hello: '',
    hello: '',
    hello:'',
    hello:'',
    hello:'',
    hello:'',
    hello:'',
    hello:'',
    hello:'',
    hello:'',
    hello:'',
    hello:'',
    hello:'',
    hello:'',
    hello:'',
    hello:'',
    
    hello: ''
}
export default messagesZh


// WEBPACK FOOTER //
// ./src/config/languages/zh_CN.js